import React, { useState, useEffect, useMemo } from "react";
import { Redirect, Link } from "react-router-dom";
import { Modal, ModalBody, ModalHeader, ModalFooter, Input} from "reactstrap";
import Pagination from "react-js-pagination";
import Footer from "../../../GlobalComponents/Footer";
import Navbar from "../Navbar";
import { repsBookingService } from "../../../../services";
import { formatDate } from "../../../../helpers/dateHelper";
import { debounce } from "lodash";

const AssignTab = () => {
const [user] = useState(JSON.parse(localStorage.getItem("user")));
const [search, setSearch] = useState("");
const [activePage, setActivePage] = useState(1);
const [limit] = useState(50);
const [totalItemsCount, setTotalItemsCount] = useState(1);
const [setList] = useState([]);
const [itemUsedModal, setItemUsedModal] = useState(false);
const [readMoreContent] = useState("");
const [readMoreModel, setReadMoreModel] = useState(false);
const [bookingList, setBookingList] = useState([]);
const [loading, setLoading] = useState(false);
const [refreshList, setRefreshList] = useState(false);

useEffect(() => {
    getList();
  }, []);

  useEffect(() => {
    // getList();
     getList(search, activePage);
  }, [search,activePage]); 
  

  useEffect(() => {
    if (refreshList === true) {
      setActivePage(1);
      getList();
      setRefreshList(false);
    }
  }, [refreshList]);

  useEffect(()=>{
    if (
        activePage != "" &&
        totalItemsCount != "" &&
        limit != ""
    ) {
        handlePageStates(
           activePage,
           totalItemsCount,
           limit
        );
    }
  },[]);
  
  const getList = () => {
    setLoading(true);
    repsBookingService.getAssignedRepList({
      working_delivery_from_date: "",
      working_delivery_to_date: "",
      operation_from_date: "",
      operation_to_date: "",
      type: ["loan"],
      reps_id: user.data._id,
      status: ["pending", "booked", "dispatch", "return","prepare","query"],
      search,
      page: activePage,
      limit,
    })
      .then((res) => {
        const result = res.data;
        setBookingList(result || []);
        setTotalItemsCount(res.total_count || result.length || 1);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };  

  const handlePageChange = (pageNumber) => {
    setBookingList([]);
    setLoading(true);
    setActivePage(pageNumber);
  };  
  

  const handlePageStates = (activePage, totalItemsCount) =>{
  setActivePage(activePage);
  setTotalItemsCount(totalItemsCount);
};

//  const handleSearch = (val) => {
//     setSearch(val);
//     setActivePage(1);
//     setTimeout(() => getList(), 0);
//   };
  
  const debouncedSearch = useMemo(
    () =>
      debounce((value) => {
        setSearch(value);
        setActivePage(1);
      }, 500),
    []
  );
  

//   const itemUsedModalOpen = (id) => {
//     bookingService.getSetList(id).then((res) => {
//       setSetList(res.data[0].bookingKitSetId);
//       setItemUsedModal(true);
//     });
//   };

  if (!user || user.data.user_role !== "reps") {
    return <Redirect to="/" />;
  }

  return (
    <div>
      <Navbar activePage="bookings" />
      <div className="container-fluid">
        <div className="row pt-4 align-items-center">
          <div className="col-md-5">
            <ul className="sub-menu">
              <li><Link to="/reps/open-booking">Open</Link></li>
              <li><Link to="/reps/reject-booking">Rejected</Link></li>
              <li><Link to="/reps/closed-booking">Closed</Link></li>
              <li><Link to="/reps/cancel-booking" >Cancelled</Link></li>
              <li><Link to="/reps/assigned-booking" className="active">Assigned to me</Link></li>
            </ul>
          </div>
          <div className="col-md-5 col-sm-12">
            <div className="form-search">
              <Input
                className="form-control mr-sm-2"
                type="text"
                placeholder="Search.."
                // value={search}
                // onChange={(e) => handleSearch(e.target.value)}
                onChange={(e) => debouncedSearch(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div id="table-scroll" className="table-scroll mt-4">
          <table id="main-table" className="main-table">
            <thead>
              <tr>
                <th scope="col" width="200">Hospital Name</th>
                <th scope="col">Contact Person</th>
                <th scope="col" style={{ minWidth: "100px" }}>Kits Required</th>
                <th scope="col" style={{ minWidth: "100px" }}>Sets</th>
                <th scope="col" style={{ minWidth: "100px" }}>Operation Name</th>
                <th scope="col" width="200">Important Dates</th>
              </tr>
            </thead>
            <tbody>
              {bookingList.length > 0 && !loading && bookingList.map((item) =>{
              console.log("cacacacac", item);
              return (
                <tr key={item?.bookings?._id}>
                  <td>
                    <Link to={`/reps/booking/details/${item.bookings._id}`}>
                      <span><strong><span className="theme-text">{item.bookings.booking_id}</span> <br />{item.hospitalId.name}</strong></span><br />
                              { item
                                                                                        .bookingSurgeonData
                                                                                        .length >
                                                                                        0 && (
                                                                                        <React.Fragment>
                                                                                            <span>
                                                                                                <small>
                                                                                                    Surgeon:
                                                                                                </small>{" "}
                                                                                                <strong>
                                                                                                    { item
                                                                                                        ?.bookingSurgeonData[0]
                                                                                                        ?.SurgeonDetail[0]
                                                                                                        ?.first_name +
                                                                                                        " " +
                                                                                                         item
                                                                                                            ?.bookingSurgeonData[0]
                                                                                                            ?.SurgeonDetail[0]
                                                                                                            ?.last_name}
                                                                                                </strong>
                                                                                            </span>
                                                                                            <br />
                                                                                        </React.Fragment>
                                                                                    )}
                                                                                    <span>
                                                                                        <small>
                                                                                            Assigned
                                                                                            Reps:
                                                                                        </small>{" "}
                                                                                        <strong>
                                                                                            { item
                                                                                                ?.assigned_rep
                                                                                                ?.first_name +
                                                                                                " " +
                                                                                                 item
                                                                                                    ?.assigned_rep
                                                                                                    ?.last_name}
                                                                                        </strong>
                                                                                    </span>
                                                                                    <br />
                      <small>Booked on {formatDate(item.bookings.createdAt)}</small><br />
                      {item.bookings.po_number !== "" && (
                        <small className="mobilehide">PO Number: {item.bookings.po_number}</small>
                      )}
                    </Link>
                  </td>
                  <td>
                    <div>
                      <strong>{item.hospitalId.contact_person_name}</strong><br />
                      <small>Location: {item.bookings.hospital_address}</small><br />
                      <small>Email: {item.hospitalId.email}</small><br />
                      <small>Phone: {item.hospitalId.contact_person_phone_number}</small><br />
                      <small>Department: {item.bookings.hospital_department}</small>
                    </div>
                  </td>
                      <td
                                                                        data-th="Kits Required"
                                                                        className="mobilehide"
                                                                    >
                                                                        <small>
                                                                            { item?.bookingkits &&
                                                                                 item?.bookingkits.map(
                                                                                    (
                                                                                        kit,
                                                                                        ind
                                                                                    ) => (
                                                                                        <React.Fragment
                                                                                            key={
                                                                                                ind
                                                                                            }
                                                                                        >
                                                                                            <div>
                                                                                                <span>
                                                                                                    {
                                                                                                        kit
                                                                                                            ?.kits[0]
                                                                                                            .name
                                                                                                    }{" "}
                                                                                                </span>
                                                                                            </div>
                                                                                        </React.Fragment>
                                                                                    )
                                                                                )}
                                                                        </small>
                                                                    </td>
                  <td>
                    <small>
                      {item.bookingKitSetId && item.bookingKitSetId.map((kset, ind) => (
                        <div key={ind}><span>{kset.setId[0].set_name}</span></div>
                      ))}
                    </small>
                  </td>
                  <td data-th="Operation Name">
														{ item.bookings
															?.operation_name ===
														"Other" ? (
															<span>
																{" "}
																{
																	 item
																		?.bookings
																		.other_opration
																}{" "}
															</span>
														) : (
															<span>
																{" "}
																{
																	 item
																		?.bookings
																		.operation_name
																}{" "}
															</span>
														)}
													</td>
                  <td>
                    <small>
                      Delivery Date: <strong>{formatDate(item.bookings.delivery_date)} {item.bookings.delivery_date_slot}</strong><br />
                      Operation Date: <strong>{formatDate(item.bookings.operation_date)} {item.bookings.operation_date_slot}</strong><br />
                      Collection Date: <strong>{formatDate(item.bookings.collection_date)}</strong>
                    </small>
                  </td>
                </tr>
              );})}
              {bookingList && bookingList.length === 0 && !loading && (
                <tr className="text-center">
                  <td colSpan="5">No Record Found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {bookingList && bookingList.length > 0 && (
          <Pagination
            activePage={activePage}
            itemsCountPerPage={limit}
            totalItemsCount={totalItemsCount}
            pageRangeDisplayed={5}
            onChange={handlePageChange}
            itemClass="page-item"
            linkClass="page-link"
            innerClass="pagination justify-content-center mb-5"
            activeLinkClass="active"
            nextPageText="Next"
            prevPageText="Prev"
          />
        )}
      </div>

      {/* Read More Modal */}
      <Modal size="md" backdrop="static" isOpen={readMoreModel} toggle={() => setReadMoreModel(false)}>
        <ModalHeader toggle={() => setReadMoreModel(false)}>Reason Of Cancellation</ModalHeader>
        <ModalBody>
          <div className="my-2">{readMoreContent}</div>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-secondary ml-2" onClick={() => setReadMoreModel(false)}>Close</button>
        </ModalFooter>
      </Modal>

      {/* Item Used Modal */}
      <Modal size="ml" backdrop="static" isOpen={itemUsedModal} toggle={() => setItemUsedModal(false)}>
        <ModalHeader toggle={() => setItemUsedModal(false)}>Item Used</ModalHeader>
        <ModalBody>
          <table className="table">
            <thead>
              <tr>
                <th>Status</th>
                <th>Set Name</th>
              </tr>
            </thead>
            <tbody>
              {setList.map((item, index) => (
                <tr key={index}>
                  <td className="align-top">
                    <Input type="checkbox" className="ml-0" readOnly checked={item.item_in_used === true} />
                  </td>
                  <td>{item.setData[0].set_name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-secondary ml-2" onClick={() => setItemUsedModal(false)}>Close</button>
        </ModalFooter>
      </Modal>

      <Footer />
    </div>
  );
};

export default AssignTab;